
import { ReactComponent as Exit } from '../../assets/icons/exit.svg';
import Swal from 'sweetalert2';
import classes from '../../App.module.scss';
import { useState, useEffect, useCallback } from 'react';
import { attemptToJoinExam, examDatails, getSchoolName, logoutUser } from '../../assets/api/userActions';
import { clearStoredUserSession, formatQuizEndDescription, formatQuizShowResultDateTime, getQuizTypeLabel, getSessionToken, getStoredUserSession, isGuestSession, isTestQuestion } from '../../assets/utils/utils';
import { showAttemptJoinErrorSwal } from '../../assets/utils/attemptJoinErrorSwal';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../../components/loading/loading';
import TestCheckboxPreviewButtons from '../../components/previewAnswerButtons/testCheckboxButtons/testCheckboxPreviewButtons';
import PreviewUploadButtons from '../../components/previewAnswerButtons/descriptiveUploadButtons/previewUplaodButton';

function GuestLogin() {

    const params = useParams();
    const navigate = useNavigate();

    const [examData, setExamData] = useState();
    // const [counter, setCounter] = useState(null);
    // const [verify, setVerify] = useState();
    const [isUserLogged, setIsUserLogged] = useState(false)
    const [schoolName, setSchoolName] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isJoinExamLoading, setIsJoinExamLoading] = useState(false);
    // const [showMessage, setShowMessage] = useState(false);
    // const [isClickedOnSentPassword, setIsClickedOnSentPassword] = useState(false)
    // const [guestInputField, setGuestInputField] = useState({
    //     name: "",
    //     phone: "",
    //     code: ""
    // });

    const LS_data = getStoredUserSession({ quizCode: params.quiz, clearInvalid: false });
    useEffect(() => {
        setIsUserLogged(!!getStoredUserSession({ quizCode: params.quiz }));
    }, [params.quiz]);

    // useEffect(() => {
    //     if (counter === 0) {
    //         setShowMessage(true)
    //         setCounter(null)
    //     }
    //     if (!counter) return;
    //     const intervalId = setInterval(() => {
    //         setCounter(counter - 1);
    //     }, 1000);
    //     return () => clearInterval(intervalId);
    // }, [counter]);


    // const successGuestLoginHandler = (data) => {
    //     if (data.status) {
    //         Swal.fire({
    //             icon: "error",
    //             title: `${data.message}`
    //         })
    //     }
    //     else {
    //         console.log(data);
    //         const today = new Date()
    //         let tomorrow = new Date()
    //         const setExpireDate = tomorrow.setDate(today.getDate() + 1);
    //         localStorage.setItem("userToken", JSON.stringify({ quizToken: data.token, expireDate: setExpireDate, name: data.name, user_id: data.user_id }))
    //         examPageHandler()
    //     }
    // }

    // const onSubmitLogin = async (res) => {

    //     // console.log(res);
    //     if (!res) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "رمز وارد شده اشتباه است",
    //             confirmButtonText: "باشه"
    //         })
    //     }
    //     else {

    //         const today = new Date()
    //         let tomorrow = new Date()
    //         const setExpireDate = tomorrow.setDate(today.getDate() + 1);
    //         localStorage.setItem("userToken", JSON.stringify({ quizToken: res.quizToken, expireDate: setExpireDate, name: guestInputField.name }))
    //         examPageHandler()
    //     }
    // }
    // const onGuestSendLogin = async () => {

    //     if (!guestInputField.name) {
    //         Swal.fire({ icon: "error", title: "لطفا اسم خود را بنویسید" })
    //     }
    //     else if (!guestInputField.phone) {
    //         Swal.fire({ icon: "error", title: "لطفا شماره را بنویسید" })
    //     }
    //     else if (!guestInputField.code) {
    //         Swal.fire({ icon: "error", title: "لطفا کد تایید را بنویسید" })
    //     }
    //     else {
    //         await confirmGuestLoginRequest({ ...guestInputField, quizCode: params.quiz }).then(res => onSubmitLogin(res));
    //     }
    // }

    // const onAuthGuestHandler = async (res) => {

    //     if (!guestInputField.name) {
    //         Swal.fire({ icon: "error", title: "لطفا اسم خود را بنویسید", confirmButtonText: "باشه" })
    //     }
    //     else if (!guestInputField.phone) {
    //         Swal.fire({ icon: "error", title: "لطفا شماره را بنویسید", confirmButtonText: "باشه" })
    //     }
    //     else {
    //         let { code, ...newData } = guestInputField;
    //         newData = { ...newData, quiz_code: params.quiz };
    //         await guestLoginPhone(newData).then(res => successGuestLoginHandler(res));
    //     }
    // }

    // const validExamHandler = (data) => {
    //     if (!data.validation) {
    //         navigate("/service/not-active");
    //     }
    //     else if (!data.guest) {
    //         navigate("/guest/not-active");
    //     }
    // }

    // const fetchGuestValidation = async () => {
    //     guestVerification(params.quiz).then(res => { setVerify(res); validExamHandler(res) });
    // }


    const fetchSchoolName = useCallback(async () => {
        await getSchoolName(params.quiz).then((res) => setSchoolName(res.schoolName));
    }, [params.quiz]);

    const fetchData = useCallback(async () => {
        const data = await examDatails(params.quiz);
        if (data.status === "not-found") {
            Swal.fire({
                icon: "error",
                title: `${data.message}`,
            });
        } else {
            setExamData(data?.quiz);
            setIsLoading(false);
            return data?.quiz?.title;
        }
        return data?.quiz?.title;
    }, [params.quiz]);

    /** نام نمایشی کاربر در سربرگ آزمون - برای جلوگیری از نمایش undefined */
    const headerDisplayName = (() => {
        if (!isUserLogged || !LS_data) return "وارد نشده";
        const name = (LS_data.name ?? "").toString().trim();
        return name || "کاربر مهمان";
    })();
    /** نام شرکت‌کننده در باکس اطلاعات آزمون */
    const participantDisplayName = (() => {
        if (!isUserLogged || !LS_data) return "وارد نشده‌اید";
        const name = (LS_data.name ?? "").toString().trim();
        return name || "کاربر مهمان (نام ثبت نشده)";
    })();

    useEffect(() => {
        const examTitle = fetchData();
        fetchSchoolName();
        examTitle.then((res) => {
            document.title = res === undefined ? `اطلاعات آزمون وجود ندارد` : `اطلاعات آزمون ${res}`;
        });
    }, [fetchData, fetchSchoolName]);

    // const guestInputHandler = (e) => {
    //     setGuestInputField({ ...guestInputField, [e.target.name]: e.target.value });
    // }




    const handleResultShow = () => {
        if (examData?.show_result === "range") {
            const fromLine = formatQuizShowResultDateTime(examData?.show_result_from);
            const toLine = formatQuizShowResultDateTime(examData?.show_result_to);
            return <>
                {fromLine ? (
                    <div className={classes.examInfo__info_container}>
                        <p className={classes.examInfo__title}>نمایش کارنامه تستی  از تاریخ:</p>
                        <p className={classes.examInfo__detail}>{fromLine}</p>
                    </div>
                ) : null}
                {toLine ? (
                    <div className={classes.examInfo__info_container}>
                        <p className={classes.examInfo__title}>نمایش کارنامه تستی  تا تاریخ:</p>
                        <p className={classes.examInfo__detail}>{toLine}</p>
                    </div>
                ) : null}
                {!toLine && fromLine ? (
                    <div className={classes.examInfo__info_container}>
                        <p className={classes.examInfo__title}>نمایش کارنامه تا:</p>
                        <p className={classes.examInfo__detail}>بدون محدودیت زمانی برای پایان نمایش</p>
                    </div>
                ) : null}
            </>;
        }
        else if (examData?.show_result === "no_display") {
            return <>
                <div className={classes.examInfo__info_container}>
                    <p className={classes.examInfo__title}>نمایش کارنامه تستی:</p>
                    <p className={classes.examInfo__detail}>عدم نمایش</p>
                </div>
            </>
        }
        else {
            return <>
                <div className={classes.examInfo__info_container}>
                    <p className={classes.examInfo__title}>نمایش کارنامه تستی:</p>
                    <p className={classes.examInfo__detail}>پس از اتمام آزمون</p>
                </div>
            </>
        }
    }

    const getQuestionOrderText = () => {
        const orderMode = examData?.questions_order_mode || (examData?.random_questions ? "random" : "default");
        return orderMode === "random" ? "تصادفی" : "به ترتیب ثبت سوالات";
    };

    const getQuestionDisplayText = () => {
        const displayMode = examData?.questions_display_mode || "all_at_once";
        return displayMode === "one_by_one" ? "تکی (هر بار یک سوال)" : "یکجا (همه سوالات)";
    };

    const getNavigationText = () => {
        const displayMode = examData?.questions_display_mode || "all_at_once";
        if (displayMode !== "one_by_one") return "نمایش یکجا (ناوبری سوال-به-سوال ندارد)";
        const navMode = examData?.question_navigation_mode || "free";
        return navMode === "forward_only" ? "فقط جلو (بدون امکان بازگشت)" : "آزاد (قبلی/بعدی)";
    };



    // const handleSendNumber = async (res) => {
    //     // console.log(res);
    //     if (res.returnCode === "SUCCESS") {
    //         setCounter(90);
    //         setIsClickedOnSentPassword(true);
    //     }
    //     else {
    //         Swal.fire({
    //             icon: "error",
    //             title: `${res.error}`
    //         })
    //     }
    // }

    // const onGuestSendPhone = async () => {
    //     var regex = new RegExp('^(\\+98|0)?9\\d{9}$');
    //     if (guestInputField.name.length <= 0) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "اسم خود را وارد کنید",
    //             confirmButtonText: "باشه"
    //         })
    //     }
    //     else if (guestInputField.phone.length !== 11 && guestInputField.phone.length !== 0) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "شماره وارد شده صحیح نمیباشد",
    //             confirmButtonText: "باشه"

    //         })
    //     }
    //     else if (!guestInputField.phone.length) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "شماره خود را وارد کنید",
    //             confirmButtonText: "باشه"
    //         })
    //     }
    //     else if (!regex.test(guestInputField.phone.toString())) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "فرمت شماره وارد شده صحیح نمیباشد",
    //             confirmButtonText: "باشه"

    //         })
    //     }
    //     else {
    //         // console.log(params.quiz);
    //         await confirmMessageRequest(guestInputField.name, guestInputField.phone, params.quiz).then(res => handleSendNumber(res));
    //     }
    // }

    const examPageHandler = async () => {
        const tokenData = getStoredUserSession({ quizCode: params.quiz });
        if (!tokenData) {
            setIsUserLogged(false);
            navigate('/auth/login/guest/' + params.quiz);
            return;
        }
        if (isJoinExamLoading) return;
        setIsJoinExamLoading(true);
        try {
            // قبل از هدایت به صفحهٔ آزمون، اعتبار join را بررسی می‌کنیم تا اگر آزمون
            // غیرفعال است یا زمان آن گذشته یا توکن نامعتبر است، پیام مناسب نمایش داده شود
            // و کاربر مهمان به مسیر پیام «نشست شما منقضی شده» پرتاب نشود.
            const joinRes = await attemptToJoinExam(params.quiz, getSessionToken(tokenData));
            if (joinRes?.message === "Unauthenticated.") {
                Swal.fire({
                    rtl: true,
                    icon: "info",
                    title: "نشست مهمان شما به پایان رسیده است",
                    text: "برای ادامه، لطفاً مجدداً به عنوان مهمان وارد شوید.",
                    confirmButtonText: "باشه",
                });
                clearStoredUserSession();
                setIsUserLogged(false);
                navigate(`/auth/login/guest/${params.quiz}`);
                return;
            }
            if (joinRes?.status !== 'joined') {
                showAttemptJoinErrorSwal(joinRes);
                return;
            }
            if (examData?.type === 'test' && examData?.question_type === 'custom') {
                navigate(`/quiz/test/${params.quiz}`);
                window.location.reload();
            } else if (examData?.type === 'mixed' && examData?.question_type === 'custom') {
                navigate(`/quiz/mixed/${params.quiz}`);
                window.location.reload();
            } else if (examData?.type === 'test' && examData?.question_type === 'pdf') {
                navigate(`/quiz/test-pdf/${params.quiz}`);
                window.location.reload();
            } else if (examData?.type === 'descriptive' && examData?.question_type === 'custom') {
                navigate(`/quiz/descriptive/${params.quiz}`);
                window.location.reload();
            } else if (examData?.type === 'descriptive' && examData?.question_type === 'pdf') {
                navigate(`/quiz/descriptive-pdf/${params.quiz}`);
                window.location.reload();
            }
        } finally {
            setIsJoinExamLoading(false);
        }
    };

    const handleLogout = useCallback(async () => {
        const session = getStoredUserSession({ quizCode: params.quiz, clearInvalid: false });
        if (!session) return;
        const guest = isGuestSession(session);
        const result = await Swal.fire({
            rtl: true,
            icon: "question",
            iconColor: "#64748b",
            title: "خروج از حساب کاربری",
            html: `
                <div style="text-align:right;font-size:15px;line-height:1.8;color:#334155;">
                    <p style="margin:0 0 10px;">با خروج، نشست فعلی شما در این مرورگر حذف می‌شود.</p>
                    <p style="margin:0;font-size:14px;color:#64748b;">برای ورود دوباره به آزمون باید ${guest ? "اطلاعات مهمان خود را مجدداً وارد کنید" : "با حساب کاربری خود دوباره وارد شوید"}.</p>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: "بله، خارج شوم",
            cancelButtonText: "انصراف",
            confirmButtonColor: "#dc2626",
            cancelButtonColor: "#64748b",
            reverseButtons: true,
        });
        if (!result.isConfirmed) return;
        await logoutUser();
        clearStoredUserSession();
        setIsUserLogged(false);
        navigate(guest ? `/auth/login/guest/${params.quiz}` : `/auth/login/${params.quiz}`, { replace: true });
    }, [navigate, params.quiz]);


    return (
        <div className={`${classes.appContainer} ${classes.examAppContainer}`} style={{ minHeight: "100vh", height: "100%" }}>
            <div className={classes.container}>
                {!isLoading ?
                    <>
                        <header className={classes.timeRemainedContainer} style={{ display: 'grid' }}>
                            <div className={classes.headerBox} >
                                <div className={`${classes.buttonContainer} ${classes.visibility_hidden} `} >
                                    <p>اتمام آزمون</p>
                                    <p >ترک آزمون</p>
                                </div>
                                <p className={`${classes.unlimited_text} ${classes.visibility_hidden} `}>زمان باقیمانده : نامحدود</p>


                                {/* <div className='time-remained'>4:20:00</div> */}
                            </div>
                            <div className={classes.informationBar}>
                                <div className={classes.examDetails}>
                                    <div className={classes.examDetailsTitle}>
                                        <h1>{examData?.title}</h1>
                                        <p>{`(${schoolName})`}</p>
                                    </div>
                                    <div id={classes.returnBtn}>
                                        <p>بازگشت به سایت</p>
                                        <div className={classes.exitIcon}>
                                            <Exit fill='#fff' width="15px" height='15px' />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.personalDetails}>
                                    <ul>
                                        <li className={classes.userIdentityItem}>
                                            <span>{`نام کاربر : ${headerDisplayName}`}</span>
                                            {isUserLogged && (
                                                <button
                                                    type="button"
                                                    className={classes.logoutIconBtn}
                                                    onClick={handleLogout}
                                                    title="خروج از حساب کاربری"
                                                >
                                                    <Exit fill="#fff" width="14px" height="14px" />
                                                </button>
                                            )}
                                        </li>
                                        <li>{`مدت آزمون : ${examData?.duration ? examData.duration + ' دقیقه ' : 'نامحدود'}`}</li>
                                        <li>{`نوع آزمون : ${getQuizTypeLabel(examData?.type)}`}</li>
                                        {
                                            examData?.type !== "mixed" && (
                                                examData?.test_type === "score" ?
                                                    <li>{`نمره کل : ${examData.total_score}`}</li>
                                                    : <li>{`ضریب منفی : ${examData?.negative_point ? examData?.negative_point.replace("/", " به ") : "ندارد"}`}</li>
                                            )
                                        }
                                        <li>{`تعداد سوالات : ${examData.number_of_question}`}</li>
                                    </ul>
                                </div>
                            </div>
                        </header>

                        <main className={classes.mainContainer}>
                            <div className={classes.answerSheetContainer}>
                                <div className={classes.answerSheetHeader}>
                                    <h3>پاسخنامه</h3>
                                    <div className={classes.answerDatasheet}>
                                        <p className={classes.answerDatasheet_answer}>{`پاسخ داده شده : ${0}`}</p>
                                        <p className={classes.answerDatasheet_notAnswer}>{`پاسخ داده نشده : ${0}`}</p>
                                    </div>
                                </div>
                                <div className={classes.answerSheet}>
                                    <ol>
                                        {
                                            examData?.questions?.map((data) => (
                                                examData.type === "test" || (examData.type === "mixed" && isTestQuestion(data)) ? (
                                                    <TestCheckboxPreviewButtons
                                                        key={data.id}
                                                        id={data.id}
                                                        quNo={data.question_number}
                                                        options={data.options}
                                                        score={data.score}
                                                        isRank={examData?.test_type}
                                                        quizType={examData?.type}
                                                        isInfo
                                                    />
                                                ) : (
                                                    <PreviewUploadButtons
                                                        key={data.id}
                                                        index={data.id}
                                                        quNo={data.question_number}
                                                        options={data.options}
                                                        score={data.score}
                                                        isInfo
                                                    />
                                                )
                                            ))
                                        }
                                    </ol>
                                </div>
                            </div>
                            {/* DISPLAY QUESTION / QUESTION SECTION  */}
                            <section className={classes.questionSection}>
                                <div className={classes.questionSection_header} style={{ alignItems: "center" }}>
                                    <h2>اطلاعات آزمون</h2>
                                    <div id={classes.returnBtn}>
                                        <p>بازگشت به سایت</p>
                                        <div className={classes.exitIcon}>
                                            <Exit fill='#fff' width="15px" height='15px' />
                                        </div>
                                    </div>
                                </div>
                                <div className={`${classes.questionContainer} ${classes.examInfo__container}`} >
                                    {
                                        <div style={{ width: "100%" }} key={examData?.id}>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>نام شرکت کننده :</p>
                                                <p className={classes.examInfo__detail}>{participantDisplayName}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>نام آموزشگاه :</p>
                                                <p className={classes.examInfo__detail}>{schoolName}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>عنوان آزمون :</p>
                                                <p className={classes.examInfo__detail}>{examData?.title}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>تعداد سوالات :</p>
                                                <p className={classes.examInfo__detail}>{examData?.number_of_question}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>نوع آزمون :</p>
                                                <p className={classes.examInfo__detail}>{getQuizTypeLabel(examData?.type)}</p>
                                            </div>
                                            {examData?.type !== "mixed" && (
                                                <div className={classes.examInfo__info_container}>
                                                    <p className={classes.examInfo__title}>ضریب منفی تست :</p>
                                                    <p className={classes.examInfo__detail}>{examData?.negative_point ? examData?.negative_point : "ندارد"}</p>
                                                </div>
                                            )}
                                            {
                                                examData?.date &&
                                                <div className={classes.examInfo__info_container}>
                                                    <p className={classes.examInfo__title}>تاریخ ورود آزمون :</p>
                                                    <p className={classes.examInfo__detail}>{examData?.date}</p>
                                                </div>
                                            }
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>شروع و ورود آزمون :</p>
                                                {examData?.start_time_from == null ? <p className={classes.examInfo__detail}>هر ساعتی</p> :
                                                    <p className={classes.examInfo__detail}>{`${examData?.start_time_from} تا ${examData?.start_time_to}`}</p>}
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>پایان آزمون :</p>
                                                <p className={classes.examInfo__detail}>{formatQuizEndDescription(examData)}</p>
                                            </div>
                                            {examData?.type !== "mixed" && handleResultShow()}
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>امکان ترک آزمون :</p>
                                                <p className={classes.examInfo__detail}>{examData?.leave === 0 ? "ندارد" : "دارد"}</p>
                                            </div>
                                            <div className={classes.examInfo__info_container}>
                                                <p className={classes.examInfo__title}>فعال بودن آزمون :</p>
                                                <p className={classes.examInfo__detail}>{examData?.active === 0 ? "غیر فعال" : "فعال"}</p>
                                            </div>
                                            {examData?.question_type === "custom" && (
                                                <>
                                                    <div className={classes.examInfo__info_container}>
                                                        <p className={classes.examInfo__title}>ترتیب نمایش سوالات :</p>
                                                        <p className={classes.examInfo__detail}>{getQuestionOrderText()}</p>
                                                    </div>
                                                    <div className={classes.examInfo__info_container}>
                                                        <p className={classes.examInfo__title}>نحوه نمایش سوالات :</p>
                                                        <p className={classes.examInfo__detail}>{getQuestionDisplayText()}</p>
                                                    </div>
                                                    <div className={classes.examInfo__info_container}>
                                                        <p className={classes.examInfo__title}>نحوه جابجایی بین سوالات :</p>
                                                        <p className={classes.examInfo__detail}>{getNavigationText()}</p>
                                                    </div>
                                                    {(examData?.questions_display_mode === "one_by_one" && examData?.question_navigation_mode === "forward_only") && (
                                                        <div className={classes.examInfo__info_container}>
                                                            <p className={classes.examInfo__title}>هشدار مهم :</p>
                                                            <p className={classes.examInfo__detail} style={{ color: "#b45309" }}>
                                                                این آزمون بدون امکان بازگشت به سوالات قبلی است. پس از رفتن به سوال بعد، امکان بازبینی سوالات قبل را نخواهید داشت.
                                                            </p>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            <div className={classes.examInfo__btn_container}>
                                                <button
                                                    type="button"
                                                    disabled={isJoinExamLoading}
                                                    onClick={() => examPageHandler()}
                                                    className={classes.examInfo__btn}
                                                >
                                                    {isJoinExamLoading
                                                        ? 'لطفاً صبر کنید…'
                                                        : 'ورود به آزمون'}
                                                </button>
                                            </div>
                                        </div>
                                        // ))
                                    }
                                    {/* <div className={classes.examInfo__login_section} style={{ display: "flex" }}>
                                        <div className={classes.examInfo__login} >
                                            <div className={classes.examInfo__login_title}>
                                                <h3>ورود مهمان</h3>
                                            </div>
                                            <div className={classes.examInfo__login_title}>
                                                <p className={classes.examInfo__login_info}>لطفا وارد حساب کاربری خود شوید</p>
                                            </div>
                                            <input type="text" placeholder='نام و نام خانوادگی' name='name' value={guestInputField.name} onChange={guestInputHandler} className={classes.examInfo__login_input} />
                                            <input type="number" placeholder='شماره تلفن' name='phone' value={guestInputField.phone} onChange={guestInputHandler} className={classes.examInfo__login_input} />
                                            {isClickedOnSentPassword && <input type="number" autoComplete="new-password" placeholder='رمز ارسال شده' name='code' value={guestInputField.code} onChange={guestInputHandler} className={classes.examInfo__login_input} style={{ marginBottom: "6px" }} />}
                                            {isClickedOnSentPassword && !showMessage && <p id={classes.resendMessage}>{`${counter} ثانیه مانده تا دریافت کد مجدد`}</p>}
                                            {showMessage && <p id={classes.forgetPassword} className={classes.examInfo__changeField} onClick={() => onGuestSendPhone()} >پیامی دریافت نکرده اید ؟<br />ارسال مجدد کد</p>}
                                            {
                                                verify.guestDetection ?
                                                    isClickedOnSentPassword ?
                                                        <button className={classes.examInfo__login_btn} onClick={() => onGuestSendLogin()} >ورود</button>
                                                        :
                                                        <button className={classes.examInfo__login_btn} onClick={() => onGuestSendPhone()} >ارسال رمز ورود</button>
                                                    :

                                                    <button className={classes.examInfo__login_btn} onClick={() => onAuthGuestHandler()} >ورود</button>

                                            }
                                            {/* <p id={classes.forgetPassword} className={classes.examInfo__changeField} onClick={() => navigate(`/quiz/join/${params.quiz}`)} >ورود کاربر</p> 
                                        </div >
                                    </div > */}

                                </div >
                            </section >
                        </main>
                    </>

                    :
                    <>
                        <Loading />
                    </>
                }
            </div>
        </div>
    );
}

export default GuestLogin;

